import * as React from "react"
export const IconStroke = (props) => {
    const fill = props?.fill || '#202020';
    return <svg width="31" height="30" viewBox="0 0 31 30" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 24L24.5 6" stroke={fill} strokeWidth="2" strokeLinecap="round" />
    </svg>
}
export default IconStroke;